import { Grid } from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';

import { CapacityProps, CapacityHourTypes } from './Capacity.props';
import { CapacityDelete, SwitchGrid } from './Capacity.styles';
import { ColorProps } from '../../../@types';
import { GRID_SPACING } from '../../../configs/ui-constants';
import { Button, ButtonVariantProps } from '../../atoms/Button';
import { FormControlLabel, FormControlLabelPlacementProps } from '../../atoms/FormControlLabel';
import { MultiSelectCheckmarksMenu } from '../../atoms/MultiSelectCheckmarksMenu';
import { SelectMenu } from '../../atoms/SelectMenu';
import { Switch } from '../../atoms/Switch';
import { TextField, TextFieldTypeProps } from '../../atoms/TextField';
import { ToogleButtonTextAlignment } from '../../atoms/ToogleButtonGroup';
import { MultiClientSelector } from '../../molecules/MultiClientSelector';

export const Capacity: React.FC<CapacityProps> = ({
  capacityData,
  disableElement,
  hasCapacityEditPermission = true,
  onChange,
  onDelete
}) => {
  const [open, setOpen] = useState(false);
  const [capacity, setCapacity] = useState(capacityData);
  const itemSelectionData = Object.values(CapacityHourTypes).map(text => ({ value: text, label: text }));

  useEffect(() => {
    capacityData && setCapacity(capacityData);
  }, [capacityData]);

  const handleType = (selectedValue: string) => {
    const item = Object.entries(CapacityHourTypes).find(capacityValue => capacityValue[1] === selectedValue);
    const getKeyByValue = item ? item[1] : CapacityHourTypes.AllDays;
    onChange({ ...capacity, type: getKeyByValue });
  };

  return (
    <Grid container spacing={GRID_SPACING} alignItems={ToogleButtonTextAlignment.Center}>
      <Grid size={{ xs: 2 }}>
        <MultiSelectCheckmarksMenu 
          id="multi-select"
          disabled={!hasCapacityEditPermission}
          label="Service Types"
          items={capacity.itemsData} 
          selectedValue={capacity?.selectedItems || []}
          onChange={(selectItem: string) => onChange({ ...capacity, selectedItems: selectItem.split(',') })} />
      </Grid>
      <Grid size={{ xs: 2 }}>
        <Button onClick={() => setOpen(true)} fullWidth={true} variant={ButtonVariantProps.Secondary}>
          {capacity.clientContractHierarchy || 'Client/Contract'}
        </Button>

        <MultiClientSelector
          open={open}
          disabled={!hasCapacityEditPermission}
          onClose={() => setOpen(false)}
          clients={capacity.clientsData}
          contracts={capacity.contractsData}
          selectedMultiClients={capacity?.selectedClients}
          selectedMultiContracts={capacity?.selectedContracts}
          handleParentSelection={(selectedClients: string[], selectedContracts: string[], clientHierarchy: string) => { 
            onChange({ ...capacity, selectedClients, selectedContracts, clientContractHierarchy: clientHierarchy });
          }}
        />
      </Grid>
      <Grid size={{ xs: 2 }}>
        <SelectMenu
          id="capacity-hour-type"
          disabled={!hasCapacityEditPermission}
          label="Day Type"
          items={itemSelectionData}
          selectedValue={capacity.type}
          onChange={(type: string) => handleType(type)}
        />
      </Grid>
      <Grid size={{ xs: 1 }}>
        <TextField
          label="Max"
          disabled={!hasCapacityEditPermission}
          type={TextFieldTypeProps.Number}
          value={capacity.max}
          onChange={(maxValue: string) => onChange({ ...capacity, max: maxValue })} />
      </Grid>
      <SwitchGrid size={{ xs: 2.35 }}>
        <FormControlLabel
          control={
            <Switch
              disabled={!hasCapacityEditPermission}
              color={ColorProps.Primary}
              checked={capacity.checkInventory}
              onChange={(event: ChangeEvent<HTMLInputElement>) => onChange({ ...capacity, checkInventory: event.target.checked })} />
          }
          label="Check Inventory"
          labelPlacement={FormControlLabelPlacementProps.Top}
        />
      </SwitchGrid>
      <SwitchGrid size={{ xs: 2.15 }}>
        <FormControlLabel
          control={
            <Switch
              disabled={!hasCapacityEditPermission}
              color={ColorProps.Primary}
              checked={capacity.allowOveride}
              onChange={(event: ChangeEvent<HTMLInputElement>) => onChange({ ...capacity, allowOveride: event.target.checked })} />
          }
          label="Allow Overide"
          labelPlacement={FormControlLabelPlacementProps.Top}
        />
      </SwitchGrid>
      {hasCapacityEditPermission && !disableElement && 
        <Grid size={{ xs: 0.5 }}>
          <CapacityDelete onClick={() => onDelete()} />
        </Grid>
      }
    </Grid>
  );
};